// extracted by mini-css-extract-plugin
module.exports = {"column":"OrderSummarySegment-Column-module--column--m7MR_","fillMd":"OrderSummarySegment-Column-module--fill-md--EA-n1"};